import { FieldDetails } from '@openx/components-core/lib/FieldDetails/FieldDetails';
import { FormSection } from '@openx/components-core/lib/FormSection/FormSection';
import type { Deal } from '@openx/types/deal';
import { useTranslation } from 'react-i18next';

import type { DealDetailsSectionProps } from '../../../types';
import { DealGroupContainer } from '../../components/DealGroup/DealGroupContainer';
import { useDealContext } from '../../utils/context/DealContext';

export type IdsSectionDeal = Pick<Deal, 'id' | 'deal_id' | 'uid'>;

export function IdsDetailsSection<T extends IdsSectionDeal = IdsSectionDeal>({
  deal,
  historyMode,
}: DealDetailsSectionProps<T>) {
  const { isOa, useDealGroupFetch } = useDealContext();
  const { t } = useTranslation();
  const { deal_id, id, uid } = deal;

  const { group, loading } = useDealGroupFetch(deal_id || '', historyMode);

  if (group.length > 1 && !historyMode) {
    return (
      <FormSection divider title={t('IDs')} data-test="ids-section-title">
        <DealGroupContainer group={group} dealId={deal_id || ''} dealUid={uid} details />
      </FormSection>
    );
  }

  return (
    <FormSection divider historyMode={historyMode} title={t('IDs')} data-test={'deal-ids'}>
      <FieldDetails
        title={t('Deal ID')}
        value={deal_id}
        copyTooltipText={t('Copy External Deal ID to clipboard')}
        copy={!historyMode}
        loading={loading}
      />
      <FieldDetails title={isOa ? t('Internal OX Deal ID') : t('ID')} value={id} copy={!historyMode} />
    </FormSection>
  );
}
